var nurseslounge_myDashboard_preceptors = {
    tab_open:'find-local-clinical',
    init:function($params){
        var $tab = nurseslounge_myDashboard_preceptors.tab_open;
        nurseslounge_myDashboard_preceptors.preceptors_tabs_events($tab, function(){
            var $all = $("#nurseslounge-home-preceptors");
            var $pTab = $all.find('#'+$tab);
            var $miles = $pTab.find('select[name="miles"]');
            nurseslounge_myDashboard_preceptors.preceptors_list_pagination($tab, undefined, $miles.val());
        });
    },
    preceptors_tabs_events:function($tab, cback){
        var $allowTabs = [
            'find-local-clinical',
            'become-paid-preceptor',
            'all-preceptors'
        ];
        var $pList = $("#nurseslounge-home-preceptors .preceptors-list");
        //Disable All
        $pList.find('.nav-pills .nav-link').addClass('disabled').removeClass('active');
        $pList.find('.tab-pane .preceptors-content').html('');
        //Events
        $pList.find('.nav-pills a[data-toggle="tab"]').unbind().on('shown.bs.tab', function ($e) {
            var $selectedTab = $e.currentTarget.dataset.target.replace('#','');
            if($.inArray($selectedTab, $allowTabs) > -1){
                if($selectedTab == 'find-local-clinical'){
                    var $all = $("#nurseslounge-home-preceptors");
                    var $pTab = $all.find('#'+$tab);
                    var $miles = $pTab.find('select[name="miles"]');
                    nurseslounge_myDashboard_preceptors.preceptors_list_pagination($selectedTab, undefined, $miles.val());
                }else if($selectedTab == 'all-preceptors'){
                    nurseslounge_myDashboard_preceptors.preceptors_list_pagination($selectedTab);
                }else{
                    nurseslounge_myDashboard_preceptors.preceptor_video('https://www.youtube.com/watch?v=tRce4vIPVCY');
                }
                //$("html, body").animate({scrollTop:$homeCe.offset().top});
            }
        });
        //Enable selected
        $.each($allowTabs, function ($i, $v) {
            $("#"+$v).removeClass('active').removeClass('show');
            $pList.find('.nav-pills .nav-link[data-target="#'+$v+'"]').removeClass('disabled');
        });
        $pList.find('.nav-pills .nav-link[data-target="#'+$tab+'"]').addClass('active');
        $("#"+$tab).addClass('active').addClass('show');
        if(cback != undefined){
            cback();
        }
    },
    preceptor_video:function($video){
        var $tab = $("#become-paid-preceptor");
        var $videoDiv = $tab.find('.video:first');
        $videoDiv.replaceWith('<div class="video"></div>');
        $videoDiv = $tab.find('.video:first');
        var $urlVideo = new URL($video);
        var $videoId = $urlVideo.searchParams.get('v');
        var $youtubePlayer = libs.memoryGet('youtubePlayer');
        if($youtubePlayer){
            $youtubePlayer.destroy();
        }
        try{
            $youtubePlayer = new YT.Player($videoDiv[0], {
                height: '660',
                width: '100%',
                videoId: $videoId,
                playerVars: {'autoplay': 1, 'controls': 1},
                events: {
                    'onReady': function () {
                        $youtubePlayer.mute();
                        $youtubePlayer.playVideoAt(0);
                    },
                    'onError': function () {
                        $videoDiv.hide();
                        libs.memorySave('youtubePlayer', null);
                        nurseslounge_myDashboard_preceptors.preceptor_video($video);
                    }
                }
            });
        }catch ($e) {

        }
        libs.memorySave('youtubePlayer', $youtubePlayer);
    },
    preceptors_list_preview:function(){
        var $chtml = '';
        for(var $i=1; $i<=6; $i++){
            $chtml+= '' +
                '<li class="shadow p-3 mb-3 bg-white rounded preview">' +
                '    <div class="row">' +
                '        <div class="col align-self-center">' +
                '            <div class="d-flex">' +
                '                <div class="profile-img mr-4 nurseslounge-home-preceptors-preload">' +
                '                 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
                '                 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
                '                </div>' +
                '                <div class="list-info align-self-center w-100">' +
                '                    <h4 class="degree-name nurseslounge-home-preceptors-preload">' +
                '                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
                '                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
                '                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
                '                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
                '                    </h4>' +
                '                    <p class="degree-university nurseslounge-home-preceptors-preload">&nbsp;</p>' +
                '                    <p class="text-muted degree-location nurseslounge-home-preceptors-preload">&nbsp;</p>' +
                '                </div>' +
                '            </div>' +
                '        </div>' +
                '        <div class="col-md-auto text-center text-sm-right align-self-center">' +
                '            <button type="button" class="btn btn-save btnAnimate">View</button>' +
                '        </div>' +
                '    </div>' +
                '</li>';
        }
        return $chtml;
    },
    preceptors_list_pagination:function($tab, $name, $miles, $states, $specialties, $cityStateZip){
        nurseslounge_myDashboard_preceptors.tab_open = $tab;
        $name = $name == undefined ? '' : $name;
        $miles = $miles == undefined ? '' : $miles;
        $states = $states == undefined ? '' : $states;
        $specialties = $specialties == undefined ? '' : $specialties;
        $cityStateZip = $cityStateZip == undefined ? '' : $cityStateZip;
        var $reload;
        var $loaded = false;
        var $tabDiv = $("#"+$tab);
        var $pContent = $tabDiv.find('.preceptors-content:first');
        var $paginationNav = $tabDiv.find('.pagination-nav:first');
        var $resultInfo = $tabDiv.find('.result-info-count:first');
        var $paginationObj;
        var $data = $.extend({}, {
            user_id:libs.memoryGet('user_id'),
            tab:$tab,
            name:$name,
            miles:$miles,
            states:$states,
            specialties:$specialties,
            city_state_zip:$cityStateZip
        });
        try{
            $paginationObj = libs.memoryGet('preceptors_list_pagination');
            if($paginationObj){
                $paginationObj.pagination('destroy');
            }
        }catch ($e) {
        }
        $paginationObj = $paginationNav.pagination({
            pageSize: 10,
            showPageNumbers: true,
            showPrevious: true,
            showNext: true,
            showNavigator: true,
            showFirstOnEllipsisShow: true,
            showLastOnEllipsisShow: true,
            dataSource:window.location.protocol +'//'+ window.location.hostname + "/myDashboard/preceptors/lists",
            locator: 'data.preceptors',
            ajax:{
                method: "POST",
                cache:false,
                dataType: "json",
                data:$data,
                beforeSend: function() {
                    $pContent.html(nurseslounge_myDashboard_preceptors.preceptors_list_preview());
                },
                complete:function($data){
                    libs.expire($data.responseJSON);
                }
            },
            totalNumberLocator: function($data) {
                return $data.data.total;
            },
            callback: function($data, $pagination) {
                $loaded = true;
                var $pageNumber = $pagination.pageNumber;
                var $pageSize = $pagination.pageSize;
                var $totalNumber = $pagination.totalNumber;
                var $first = $totalNumber > 0 ? (($pageNumber-1) * $pageSize) + 1 : 0;
                var $last = $totalNumber > 0 ? ($first + $data.length - 1) : 0;
                $paginationNav.removeClass('preceptor-list-preload');
                $resultInfo.removeClass('preceptor-list-preload').html('<strong>Showing '+$first+' - '+$last+' of '+$totalNumber+'</strong> results for <span class="link-color">Preceptors</span>');
                var $chtml = nurseslounge_myDashboard_preceptors.item_html($data);
                if($chtml != ''){
                    libs.checkImageLoad($($chtml).find('img'), function () {
                        $pContent.html('').html($chtml).promise().done(function () {
                            nurseslounge_myDashboard_preceptors.list_events($tab);
                        });
                    });
                }else{
                    var $txt = '';
                    switch ($tab) {
                        case 'find-local-clinical':
                            $txt = 'No preceptors found';
                            break;
                        case 'all-preceptors':
                            $txt = 'No preceptors found';
                            break;
                    }
                    $chtml = '' +
                        '<div class="col-12 mt-5">' +
                        '   <h5 class="w-100 text-center soft py-5 text-info">' +
                        $txt +
                        '   </h5>' +
                        '</div>';
                    $pContent.html($chtml);
                }
            }
        });
        libs.memorySave('preceptors_list_pagination', $paginationObj);
        $reload = setTimeout(function(){
            if(!$loaded){
                nurseslounge_myDashboard_preceptors.preceptors_list_pagination($tab, $name, $miles, $states, $specialties);
            }else{
                clearTimeout($reload);
            }
        }, 20000);
    },
    item_html:function($data){
        var $chtml = '';
        $.each($data, function($i, $v){
            var $id = $v.id;
            var $name = $v && $v.name ? $v.name : '';
            var $specialties = [];
            $.each($v.specialties, function($si, $sv){
                $specialties.push($sv.specialty.specialty);
            });
            $specialties = $specialties.join(',');
            var $city = $v && $v.city ? $v.city : '';
            var $state = $v && $v.state ? $v.state : '';
            var $abbreviation = $state && $state.abbreviation ? $state.abbreviation : '';
            var $img = $v.photo_root_widget +'?resize=80';
                $chtml+='' +
                '<li class="shadow p-3 mb-3 bg-white rounded item" data-id="'+$id+'">' +
                '    <div class="row open-degree">' +
                '        <div class="col align-self-center">' +
                '            <div class="d-flex">' +
                '                <div class="profile-img mr-4">' +
                '                    <img src="'+$img+'" alt="preceptor">' +
                '                </div>' +
                '                <div class="list-info align-self-center w-100">' +
                '                   <h4 class="preceptor-name">'+$name+'</h4>' +
                '                   <p class="preceptor-specialties">'+$specialties+'</p>' +
                '                   <p class="text-muted city-location">'+$city+', '+$abbreviation+'</p>' +
                '                </div>' +
                '            </div>' +
                '        </div>' +
                '        <div class="col-md-auto text-center text-sm-right align-self-center">' +
                '            <button type="button" class="btn btn-save btnAnimate open-preceptor">View</button>' +
                '        </div>' +
                '    </div>' +
                '</li>';
        });
        return $chtml;
    },
    list_events:function($tab){
        var $pList = $("#nurseslounge-home-preceptors .preceptors-list");
        var $pContent = $pList.find('.preceptors-content');
        var $item = $pContent.find('.item');
        $item.unbind().click(function(){
            var $that = $(this);
            var $id = $that.data('id');
            nurseslounge_myDashboard_preceptors.open_preceptor({
                user_id:libs.memoryGet('user_id'),
                id:$id
            });
        });
        //Search Events
        var $keyPressBinding;
        var $all = $("#nurseslounge-home-preceptors");
        var $pTab = $all.find('#'+$tab);
        var $name = $pTab.find('input[name="name"]');
        var $miles = $pTab.find('select[name="miles"]');
        var $states = $pTab.find('select[name="states"]');
        var $specialties = $pTab.find('select[name="specialties"]');
        var $cityStateZip = $pTab.find('input[name="city_state_zip"]');
        var $titleWrapper = $pTab.find('.title-wrapper');
        var $cityStateZipWrapper = $pTab.find('.city_state_zip-wrapper');
        $name.unbind().on('keyup keydown keypress', function(){
            var $that = $(this);
            var $tab = $that.data('tab');
            var $nameVal = $name.val();
            var $milesVal = $miles.val();
            var $statesVal = $states.val();
            var $specialtiesVal = $specialties.val();
            var $cityStateZipVal = $cityStateZip.val();
            try{
                clearTimeout($keyPressBinding);
            }catch($e){

            }
            $keyPressBinding = setTimeout(function(){
                nurseslounge_myDashboard_preceptors.preceptors_list_pagination(
                    $tab,
                    $nameVal,
                    $milesVal,
                    $statesVal,
                    $specialtiesVal,
                    $cityStateZipVal
                );
            }, 5000);
        });
        nurseslounge_myDashboard_preceptors.preceptor_autocomplete(
            $name,
            {
                tab:nurseslounge_myDashboard_preceptors.tab_open,
                user_id:libs.memoryGet('user_id')
            },
            "/myDashboard/preceptors/autocomplete",
            function($keyword){
                try{
                    clearTimeout($keyPressBinding);
                }catch ($e) {

                }
                var $nameVal = $name.val();
                var $milesVal = $miles.val();
                var $statesVal = $states.val();
                var $specialtiesVal = $specialties.val();
                var $cityStateZipVal = $cityStateZip.val();
                nurseslounge_myDashboard_preceptors.preceptors_list_pagination(
                    nurseslounge_myDashboard_preceptors.tab_open,
                    $nameVal,
                    $milesVal,
                    $statesVal,
                    $specialtiesVal,
                    $cityStateZipVal,
                );
            }
        );
        if($name.length > 0){
            $titleWrapper.removeClass('d-none');
            $titleWrapper.fadeIn();
        }

        $cityStateZip.unbind().on('keyup keydown keypress', function(){
            var $that = $(this);
            var $tab = $that.data('tab');
            var $nameVal = $name.val();
            var $milesVal = $miles.val();
            var $statesVal = $states.val();
            var $specialtiesVal = $specialties.val();
            var $cityStateZipVal = $cityStateZip.val();
            try{
                clearTimeout($keyPressBinding);
            }catch($e){

            }
            $keyPressBinding = setTimeout(function(){
                nurseslounge_myDashboard_preceptors.preceptors_list_pagination(
                    $tab,
                    $nameVal,
                    $milesVal,
                    $statesVal,
                    $specialtiesVal,
                    $cityStateZipVal
                );
            }, 2000);
        });
        if($cityStateZip.length > 0){
            $cityStateZipWrapper.removeClass('d-none');
            $cityStateZipWrapper.fadeIn();
        }

        $miles.unbind().change(function(){
            var $nameVal = $name.val();
            var $milesVal = $miles.val();
            var $statesVal = $states.val();
            var $specialtiesVal = $specialties.val();
            var $cityStateZipVal = $cityStateZip.val();
            nurseslounge_myDashboard_preceptors.preceptors_list_pagination(
                nurseslounge_myDashboard_preceptors.tab_open,
                $nameVal,
                $milesVal,
                $statesVal,
                $specialtiesVal,
                $cityStateZipVal,
            );
        });
        if($miles.length > 0){
            $miles.removeClass('d-none');
            $miles.fadeIn();
        }

        try{
            $states.chosen("destroy");
        }catch (e) {}
        $states.chosen();
        $states.unbind().change(function(){
            var $that = $(this);
            var $tab = $that.data('tab');
            var $nameVal = $name.val();
            var $milesVal = $miles.val();
            var $statesVal = $states.val();
            var $specialtiesVal = $specialties.val();
            var $cityStateZipVal = $cityStateZip.val();
            try{
                clearTimeout($keyPressBinding);
            }catch($e){

            }
            $keyPressBinding = setTimeout(function(){
                nurseslounge_myDashboard_preceptors.preceptors_list_pagination(
                    $tab,
                    $nameVal,
                    $milesVal,
                    $statesVal,
                    $specialtiesVal,
                    $cityStateZipVal
                );
            }, 800);
        });
        if($states.length > 0){
            $states.fadeIn();
        }

        try{
            $specialties.chosen("destroy");
        }catch (e) {}
        $specialties.chosen();
        $specialties.unbind().change(function(){
            var $that = $(this);
            var $tab = $that.data('tab');
            var $nameVal = $name.val();
            var $milesVal = $miles.val();
            var $statesVal = $states.val();
            var $specialtiesVal = $specialties.val();
            var $cityStateZipVal = $cityStateZip.val();
            try{
                clearTimeout($keyPressBinding);
            }catch($e){

            }
            $keyPressBinding = setTimeout(function(){
                nurseslounge_myDashboard_preceptors.preceptors_list_pagination(
                    $tab,
                    $nameVal,
                    $milesVal,
                    $statesVal,
                    $specialtiesVal,
                    $cityStateZipVal
                );
            }, 800);
        });
        if($specialties.length > 0){
            $specialties.fadeIn();
        }
    },
    preceptor_autocomplete:function($target, $data, $url, cback){
        try {
            $($target).autocomplete("destroy");
        }catch (e) {
        }
        var $value = '';
        $($target).autocomplete({
            minLength	:2,
            search		: function(){
                $(this).addClass("ui-autocomplete-loading");
            },
            open 		: function(){
                $(this).removeClass("ui-autocomplete-loading");
            },
            source: function(request, response) {
                $.ajax({
                    method: 'POST',
                    url:$url,
                    data:$.extend({},{
                        keyword:$($target).val()
                    }, $data),
                    dataType: "json",
                    success: function($data){
                        libs.expire($data);
                        $value = '';
                        response($data);
                    }
                });
            },
            create:function(){
                $(this).prev().remove();
                $(this).trigger("keypress.autocomplete");
            },
            select: function (event, ui) {
                $value = ui.item.value;
                $(this).val($value);
                cback($value);
                return false;
            }
        }).keypress(function ($e) {
            if ($e.which == 13) {
                cback($(this).val());
                $(this).autocomplete("close");
            }
        });
    },
    open_preceptor:function($data){
        $.ajax({
            url: "/myDashboard/myProfile/preceptor/visits",
            method: "POST",
            cache: false,
            dataType: "json",
            data: $data,
            success: function ($data) {
                if($data.data.preceptor_url){
                    window.open($data.data.preceptor_url, '_blank', '');
                }
            }
        });
    },

};
